import { ApiMediaWithCrops } from "@edco/apollo";

export type PaginationOptions = {
  pageSize?: number,
  pageIndex?: number
};

export interface SearchResultDto {
  id: string;
  name: string;
  url: string;
  contentType: string;
  searchGroupName: string | null;
  searchTitle: string | null;
  searchDescription: string | null;
  searchThumbnail: ApiMediaWithCrops | null;
}

export type SearchResponseDto = {
  items: SearchResultDto[],
  total: number
};

export function useSupportSearchResource () {
  function getResults ( query?: string, options?: PaginationOptions ): Promise<SearchResponseDto> {
    const computedUrl = computed( () => {
      let url_ = "/api/support/search?";

      const queryUnref = unref( query );
      if ( queryUnref?.length ) {
        url_ += `query=${queryUnref}`;
      }

      const pageIndexUnref = unref( options?.pageIndex );
      if ( pageIndexUnref ) {
        url_ += `&pageIndex=${pageIndexUnref}`;
      }

      const pageSizeUnref = unref( options?.pageSize );
      if ( pageSizeUnref ) {
        url_ += `&pageSize=${pageSizeUnref}`;
      }

      url_ += "&expand=all";

      url_ = url_.replace( /[?&]$/, "" );

      return url_;
    } );

    const options_ = {
      headers: {
        Accept: "application/json",
      },
      watch: [computedUrl],
    };

    return $apiFetch<SearchResponseDto>( computedUrl.value, options_ );
  }

  return {
    getResults,
  };
}
